<template>
    <div class="sidebar">
        <div class="sidebar-listing">
            <span class="close-side-bar" @click="$emit('closeSidemenu')">
                <i class="icon-delete"></i>
            </span>
            <div v-if="!activeDataSegmentList.length">
                <div class="skeleton-wrapper-inner">
                    <div class="skeleton-wrapper-body">
                        <div class="skeleton-avatar"></div>
                    </div>
                </div>
            </div>
            <div v-else id="style-3" class="country-selection scrollable">
                <ul>
                    <li
                        v-for="(list, index) in activeDataSegmentList"
                        :key="index"
                        @click="$emit('onClick')"
                    >
                        <a
                            href="javascript:void(0)"
                            :class="
                                list._id == dataSegmentId
                                    ? 'router-link-exact-active router-link-active'
                                    : ''
                            "
                            @click.prevent="
                                setDataSegmentIdAndType(
                                    index,
                                    list._id,
                                    list.dataSegmentType
                                )
                            "
                        >
                            <span>{{ list.code }}</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="sidebar-nav">
                <div class="logo-container">
                    <base-logo></base-logo>
                </div>
                <div class="navigation">
                    <ul>
                        <li
                            v-for="(list, index) in allowedSidelinksListing"
                            :key="index"
                            @click="$emit('onClick')"
                        >
                            <router-link :to="list.anchorLink">
                                <i :class="list.icon"></i>
                                <span>{{ list.menuLabel }}</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
                <login-popover></login-popover>
            </div>
        </div>
        <login-detail> </login-detail>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import loginDetail from '@/components/LoginDetail.vue'
import loginPopover from '@/components/LoginPopover.vue'
import resource from '@/api/resource'
import _ from 'lodash'
const dataSegmentApi = new resource('access-control/data-segments')
const viewBrandingApi = new resource('configurations/branding')
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: { loginDetail, loginPopover },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            dataSegmentListing: [],
            userDataSegmentIds: [],
            // Data Segment listing variables
            query: {
                startAt: 1,
                keyword: '',
                perPage: 1000,
                roleId: null,
                dataSegmentId: null,
                status: 'active',
            },
            image: 'profile-pic.png',
            sidelinksListing: [
                {
                    anchorLink: '/insights',
                    icon: 'icon-insights',
                    menuLabel: 'Insights',
                    permission: [
                        'view-alerts',
                        'view-activity-dashboard',
                        'view-customer-statistics',
                    ],
                },
                {
                    anchorLink: '/customer-profiles',
                    icon: 'icon-customer-profil',
                    menuLabel: 'Customers',
                    permission: ['view-customer-profile'],
                },
                {
                    anchorLink: '/register-customer',
                    icon: 'icon-add-customer',
                    menuLabel: 'Register Customer',
                    permission: ['register-customer'],
                },
                {
                    anchorLink: '/details-form',
                    icon: 'icon-add-customer',
                    menuLabel: 'Details Form',
                    permission: ['details-form'],
                },
                {
                    anchorLink: '/configuration',
                    icon: 'icon-configurations',
                    menuLabel: 'Configurations',
                    permission: [
                        'idenfo-engine',
                        'client-black-list',
                        'idenfo-black-list',
                        'dow-jones-list',
                        'world-check-list',
                        'form-builder',
                        'initiate-simulation-process',
                        'branding',
                        'ocr',
                    ],
                },
                {
                    anchorLink: '/system-users',
                    icon: 'icon-system-users',
                    menuLabel: 'System Users',
                    permission: [
                        'view-system-users',
                        'manage-system-users',
                        'view-roles',
                        'manage-roles',
                        'view-data-segments',
                        'manage-data-segments',
                        'view-application-access',
                        'manage-application-access',
                    ],
                },
                {
                    anchorLink: '/system-logs',
                    icon: 'icon-system-log',
                    menuLabel: 'System Logs',
                    permission: ['system-logs'],
                },
            ],
            dataSegmentId: null,
            dataSegmentType: null,
            activeDataSegId: 1,
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['user', 'scopes', 'refreshDataSegmentList']),
        allowedSidelinksListing() {
            return this.sidelinksListing.filter((item) => {
                let permission = this.checkPermission(item.permission)
                // //console.log("permission " , permission)

                if (item.permission == 'corporate-form') {
                    if (this.dataSegmentType == 'corporate') {
                        permission = true
                    } else {
                        permission = false
                    }
                }
                return permission
            })
        },
        activeDataSegmentList() {
            return this.dataSegmentListing.filter((item) => {
                return (item.status = 'active')
            })
        },
    }, // End of Component > computed

    computed: {
        ...mapGetters(['user', 'scopes', 'refreshDataSegmentList']),
        allowedSidelinksListing() {
            return this.sidelinksListing.filter((item) => {
                return this.checkPermission(item.permission)
            })
        },
        activeDataSegmentList() {
            return this.dataSegmentListing.filter((item) => {
                return (item.status = 'active')
            })
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentType(value) {
            if (value) {
                this.$store.commit('setDataSegmentType', value)
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.$store.commit('setDataSegmentId', value)
            }
        },
        user(value) {
            if (!value && this.$route.meta.requiresAuth) {
                this.$router.push({ name: 'login-page' })
            }
        }, // End of user() method
        refreshDataSegmentList(value) {
            if (value) {
                this.getRecords()
                this.$store.commit('setRefreshDataSegmentList', false)
            }
        }, // End of refreshDataSegmentList() method
    }, // End of Component > watch
    async created() {
        // Load All Data Segments
        if (!localStorage.getItem('displaySettings')) {
            await this.getBrandingData()
        }
        await this.getRecords()
    }, // End of Component > created
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getRecords() {
            let self = this
            // Data segments option list
            let { data } = await dataSegmentApi.list(self.query)
            let dataSegmentId = null
            let localStorageTem = localStorage.getItem('dataSegmentId')
            let localStorageTemSegment = localStorage.getItem('dataSegmentType')
            let dataSegmentType = null
            if (self.user && data.data) {
                if (
                    self.user.dataSegmentIds &&
                    self.user.dataSegmentIds.length
                ) {
                    self.userDataSegmentIds = self.user.dataSegmentIds
                    data.data.forEach(function (ele) {
                        if (
                            self.userDataSegmentIds.includes(ele._id) &&
                            ele.status == 'active'
                        ) {
                            self.dataSegmentListing.push(ele)
                        }
                    })
                    dataSegmentId = self.dataSegmentListing[0]._id
                    dataSegmentType = self.dataSegmentListing[0].dataSegmentType
                } else {
                    self.dataSegmentListing = data.data
                    if (self.dataSegmentListing.length) {
                        dataSegmentId = self.dataSegmentListing[0]._id
                        dataSegmentType =
                            self.dataSegmentListing[0].dataSegmentType
                    }
                }
                if (localStorageTem) {
                    let check = this.dataSegmentListing.find(
                        (x) => x._id === localStorageTem
                    )
                    if (check) {
                        this.dataSegmentId = localStorageTem
                    } else {
                        this.dataSegmentId = dataSegmentId
                    }
                } else {
                    localStorage.setItem('dataSegmentId', dataSegmentId)
                    this.dataSegmentId = dataSegmentId
                    // localStorage.setItem('dataSegmentType', dataSegmentType)
                    // this.dataSegmentType = dataSegmentType;
                }

                if (localStorageTemSegment) {
                    let check = this.dataSegmentListing.find(
                        (x) => x.dataSegmentType === localStorageTemSegment
                    )
                    if (check) {
                        this.dataSegmentType = localStorageTemSegment
                    } else {
                        this.dataSegmentType = dataSegmentType
                    }
                } else {
                    localStorage.setItem('dataSegmentType', dataSegmentType)
                    this.dataSegmentType = dataSegmentType
                }
            }
            // Get all data segments in dataSegmentListing
        }, // End of getOptionsList() method
        setDataSegmentIdAndType(val, id, type) {
            this.activeDataSegId = val
            this.dataSegmentId = id
            localStorage.setItem('dataSegmentId', id)

            this.dataSegmentType = type
            localStorage.setItem('dataSegmentType', type)
        },
        checkPermission(scopes) {
            return !!_.intersection(scopes, this.scopes).length
        },
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        }, // End of getBrandingData() method
    }, // End of Component > methods
} // End of export default
</script>
